import React from 'react';
import styled from 'styled-components';

import { CarView } from '@/components/CarView';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  selectCreditInitialValuesData,
  selectCreditPrepayment,
  setCreditPrepayment,
} from '@/store/reducers/detailed-car';
import { maxPrepayment } from '@/components/modals/CreditModal/constants';

import { BodyProps } from './types';
import { leasingInfo, minLeasingPrepayment } from './constants';

function Body({ creditType, body }: BodyProps) {
  const dispatch = useTypedDispatch();
  const creditPrepayment = useTypedSelector(selectCreditPrepayment);
  const creditInitialValuesData = useTypedSelector(
    selectCreditInitialValuesData
  );

  return (
    <Component>
      <CarView
        bodyType={body}
        min={
          creditInitialValuesData?.[
            creditType === 'credit' ? 'CREDIT' : 'LEASING'
          ]?.minPrepayment ?? 0
        }
        max={maxPrepayment}
        value={creditPrepayment}
        info={
          creditType === 'leasing' && creditPrepayment >= minLeasingPrepayment
            ? leasingInfo
            : undefined
        }
        onChange={(value) => dispatch(setCreditPrepayment(value))}
      />
    </Component>
  );
}

export default Body;

const Component = styled.div`
  margin-top: 25px;
`;
